import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { ApAccordionModule } from '@ap/accordion';
import { ApContentModule } from '@ap/content';

import { LoginAccordionComponent } from './login-accordion.component';

/**
 * @ngdoc module
 * @name LoginAccordionModule
 */
@NgModule({
    declarations: [LoginAccordionComponent],
    imports: [ApAccordionModule, ApContentModule, CommonModule],
    exports: [LoginAccordionComponent]
})
export class LoginAccordionModule {}
